import React from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useController } from "react-hook-form";
import { SortableUploadList } from "./SortableUploadList";

export const ControlledSortableUploader = ({ name, control }) => {
  const { field } = useController({ name, control });

  const { onChange, value: fileList = [] } = field;

  const handleAntdChange = (info) => {
    const isValid = info.fileList.some((x) => {
      return x.size / 1024 / 1024 > 1;
    });
    if (isValid) {
      message.error("image size cannot greater than 1mb");
      return;
    }
    if (info.fileList.length > 8) {
      message.error("maximum can upload 8 image");
      return;
    }
    const newFileList = info.fileList.filter((file) => file.status !== "removed");

    onChange(newFileList);
  };

  const handleSortEnd = (newOrderedList) => {
    onChange(newOrderedList);
  };

  const handleRemove = (fileToRemove) => {
    const newFileList = fileList.filter((file) => file.uid !== fileToRemove.uid);

    onChange(newFileList);

    message.warning(`${fileToRemove.name} removed`);
  };

  const checkResolution = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const { width, height } = img;
        const min = 330;
        const max = 2048;
        const isValid = width >= 330 && height >= 330;
        // const isValid = width >= 330 && height >= 330 && width <= 2048 && height <= 2048;
        URL.revokeObjectURL(img.src); // 释放内存

        if (!isValid) {
          message.error(
            `Image dimensions must be between ${min}px and ${max}px. Current: ${width}x${height}px`
          );
          reject();
        } else {
          resolve();
        }
      };
    });
  };

  const uploadProps = {
    beforeUpload: async (file) => {
      try {
        await checkResolution(file);
      } catch (e) {
        return Upload.LIST_IGNORE; // 校验失败，不加入列表
      }
      return new Promise(async (resolve) => {
        if (file.type && file.type.startsWith("image")) {
          try {
            file.thumbUrl = await getBase64(file);
          } catch (error) {
            //console.error("生成 thumbUrl 失败:", error);
          }
        }
        resolve(false);
      });
    },
    accept: ".jpg,.jpeg,.png",
    onChange: handleAntdChange,
    multiple: true,
    showUploadList: false,
    fileList: fileList,
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <div>
      <Upload {...uploadProps}>
        {fileList.length >= 8 ? null : <Button icon={<UploadOutlined />}>Click to upload</Button>}
      </Upload>

      {fileList.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <SortableUploadList fileList={fileList} onSort={handleSortEnd} onRemove={handleRemove} />
        </div>
      )}
    </div>
  );
};
